import { emptySplitApi } from './injectApi';

const startPackApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    // Start pack
    getStartPack: build.query({
      query: (params) => ({
        url: `/sales-admin/sales/admin/startpacks`,
        method: 'GET',
        params,
      }),
      providesTags: ['Stock'],
    }),
    putStartPack: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/${data.id}/partners/${data.partnerId}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Stock'],
    }),
    postStartPack: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/partners/${data.partnerId}`,
        method: 'POST',
        data: {
          identifiers: data.identifiers,
        },
      }),
      invalidatesTags: ['Stock'],
    }),
    postAssignStartPackWithFile: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/partners/${data.partnerId}/file`,
        method: 'POST',
        data: data.form,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      invalidatesTags: ['Stock'],
    }),
    postAssignStartPackWithFileTransfer: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/partners/file/transfer`,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      invalidatesTags: ['Stock'],
    }),
    postAssignStartPackWithList: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/partners/${data.partnerId}/list`,
        method: 'POST',
        data: data.body,
      }),
      invalidatesTags: ['Stock'],
    }),
    postAssignStartPackWithListTransfer: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/partners/list/transfer`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Stock'],
    }),
    postAssignStartPackHubWithFile: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/hubs/${data.hubID}/file`,
        method: 'POST',
        data: data.form,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      invalidatesTags: ['Stock'],
    }),
    postAssignStartPackHubWithList: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/hubs/${data.hubID}/file`,
        method: 'POST',
        data: data.body,
      }),
      invalidatesTags: ['Stock'],
    }),
    postStartPackWithRange: build.mutation({
      query: ({ minId, maxId, partnerId }) => ({
        url: `/sales-admin/sales/admin/startpacks/minId/${minId}/maxId/${maxId}/partners/${partnerId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Stock'],
    }),
    postStartPackWithRangeTransfer: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/startpacks/partners/range/transfer`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Stock'],
    }),
    postStartPackHub: build.mutation({
      query: ({ minId, maxId, hubId }) => ({
        url: `/sales-admin/sales/admin/startpacks/minId/${minId}/maxId/${maxId}/hubs/${hubId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Stock'],
    }),
  }),
  overrideExisting: false,
});

export const startPackApiHooks = {
  useGetStartPack: startPackApi.useGetStartPackQuery,
  usePutStartPack: startPackApi.usePutStartPackMutation,
  usePostStartPack: startPackApi.usePostStartPackMutation,
  usePostAssignStartPackWithFile: startPackApi.usePostAssignStartPackWithFileMutation,
  usePostAssignStartPackWithList: startPackApi.usePostAssignStartPackWithListMutation,
  usePostAssignStartPackHubWithFile: startPackApi.usePostAssignStartPackHubWithFileMutation,
  usePostAssignStartPackHubWithList: startPackApi.usePostAssignStartPackHubWithListMutation,
  usePostStartPackWithRange: startPackApi.usePostStartPackWithRangeMutation,
  usePostStartPackHub: startPackApi.usePostStartPackHubMutation,
  usePostAssignStartPackWithListTransfer: startPackApi.usePostAssignStartPackWithListTransferMutation,
  usePostAssignStartPackWithFileTransfer: startPackApi.usePostAssignStartPackWithFileTransferMutation,
  usePostStartPackWithRangeTransfer: startPackApi.usePostStartPackWithRangeTransferMutation,
};
